import { render, staticRenderFns } from "./TicketBoardCardTemplate.vue?vue&type=template&id=6c2ef812&scoped=true"
import script from "./TicketBoardCardTemplate.vue?vue&type=script&lang=js"
export * from "./TicketBoardCardTemplate.vue?vue&type=script&lang=js"
import style0 from "./TicketBoardCardTemplate.vue?vue&type=style&index=0&id=6c2ef812&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2ef812",
  null
  
)

export default component.exports